import clsx from 'clsx';
import { PropsWithChildren } from 'react';

export interface ButtonGroupProps extends PropsWithChildren {
    equalWidth?: boolean;
}

export const ButtonGroup = ({ children, equalWidth = false }: ButtonGroupProps) => (
    <div
        data-component="button-group"
        className={clsx('r-my-4 r-flex r-flex-wrap r-items-center r-gap-4 [&>.resurs-button]:r-mr-0', {
            '[&>*]:r-min-w-max [&>*]:r-flex-1': equalWidth,
        })}
    >
        {children}
    </div>
);
